import React from "react";
import { Box, Typography } from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import story1 from "../images/801A0469.jpg";
import story2 from "../images/GF team 3.jpg";
import "./StoryHighlightSection.css";
const stories = [
  {
    bg: "#e3f0ff",
    iconColor: "#0076ff",
    title: "Raji’s Been A Migrant Worker Since She Was Just 12",
    text: "Raji is a migrant worker since she was just 12. Despite having immense interest in education, she was forced to be a migrant worker due to lack of opportunity and support. She having no regret of those lost 10 years, now is showing much interest in learning and is also supporting underprivileged children learn.",
    img: story1,
    imgAlt: "Raji and child",
  },
  {
    bg: "#f1fae6",
    iconColor: "#2eaf3b",
    title: "A Brighter Future — For Indian’s Children",
    text: "As a part of educational drive, we have been trying to improvise the educational situation of India. Today along with a few supporting organizations we have being gunning to set up a few free of cost learning centers for children of remote areas.",
    img: story2,
    imgAlt: "Children behind window",
  },
];

const StoryHighlightSection = () => (
  <Box className="story-highlight-container" sx={{ maxWidth: 1200, mx: "auto", my: 8, px: 2 }}>
    {stories.map((story, idx) => (
      <Box
        key={idx}
        className="story-highlight-item"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          background: story.bg,
          borderRadius: "1.5rem",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          mb: 8,
          overflow: "hidden",
          height: { xs: "auto", md: "500px" },
        }}
      >
        {/* ✅ SWITCH ORDER BASED ON INDEX */}
        {idx === 1 ? (
          <>
            {/* CONTENT FIRST */}
            <Box
              className="story-highlight-content"
              sx={{
                width: { xs: "100%", md: "50%" },
                p: { xs: 3, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormatQuoteIcon
                className="story-highlight-icon"
                sx={{ color: story.iconColor, fontSize: 50, mb: 1 }}
              />
              <Typography
                className="story-highlight-title"
                variant="h6"
                sx={{ fontWeight: 800, mb: 2, color: "#222" }}
              >
                {story.title}
              </Typography>
              <Typography className="story-highlight-text" sx={{ fontSize: "1.05rem", color: "#333" }}>
                {story.text}
              </Typography>
            </Box>

            {/* IMAGE SECOND (Right Side) */}
            <Box
              className="story-highlight-image-container"
              sx={{
                width: { xs: "100%", md: "50%" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box
                className="story-highlight-image"
                component="img"
                src={story.img}
                alt={story.imgAlt}
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  borderRadius: 2,
                  boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
                  objectFit: "cover",
                }}
              />
            </Box>
          </>
        ) : (
          <>
            {/* IMAGE FIRST */}
            <Box
              className="story-highlight-image-container"
              sx={{
                width: { xs: "100%", md: "50%" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box
                className="story-highlight-image"
                component="img"
                src={story.img}
                alt={story.imgAlt}
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  borderRadius: 2,
                  boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* CONTENT SECOND */}
            <Box
              className="story-highlight-content"
              sx={{
                width: { xs: "100%", md: "50%" },
                p: { xs: 3, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormatQuoteIcon
                className="story-highlight-icon"
                sx={{ color: story.iconColor, fontSize: 50, mb: 1 }}
              />
              <Typography
                className="story-highlight-title"
                variant="h6"
                sx={{ fontWeight: 800, mb: 2, color: "#222" }}
              >
                {story.title}
              </Typography>
              <Typography className="story-highlight-text" sx={{ fontSize: "1.05rem", color: "#333" }}>
                {story.text}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    ))}
  </Box>
);

export default StoryHighlightSection;
